import React, { useEffect } from "react";
import Icon from "components/AppIcon";

const TOAST_CONFIG = {
  success: { icon: "CheckCircle2", color: "var(--color-success)", bg: "rgba(5,150,105,0.1)", border: "rgba(5,150,105,0.3)" },
  error: { icon: "XCircle", color: "var(--color-error)", bg: "rgba(220,38,38,0.1)", border: "rgba(220,38,38,0.3)" },
  info: { icon: "Info", color: "var(--color-primary)", bg: "rgba(59,76,76,0.08)", border: "rgba(59,76,76,0.2)" },
  warning: { icon: "AlertTriangle", color: "var(--color-warning)", bg: "rgba(217,119,6,0.1)", border: "rgba(217,119,6,0.3)" },
};

export default function ToastNotification({ toasts = [], onDismiss }) {
  return (
    <div
      className="fixed bottom-6 right-6 flex flex-col gap-2 pointer-events-none"
      style={{ zIndex: "var(--z-toast)" }}
    >
      {toasts?.map((toast) => {
        const cfg = TOAST_CONFIG?.[toast?.type] || TOAST_CONFIG?.info;
        return (<ToastItem key={toast?.id} toast={toast} cfg={cfg} onDismiss={onDismiss} />);
      })}
    </div>
  );
}

function ToastItem({ toast, cfg, onDismiss }) {
  useEffect(() => {
    const timer = setTimeout(() => onDismiss(toast?.id), 4000);
    return () => clearTimeout(timer);
  }, [toast?.id, onDismiss]);

  return (
    <div
      className="pointer-events-auto flex items-start gap-3 px-4 py-3 rounded-lg border shadow-md max-w-sm"
      style={{ background: cfg?.bg, borderColor: cfg?.border, backdropFilter: "blur(8px)" }}
    >
      <Icon name={cfg?.icon} size={16} color={cfg?.color} className="flex-shrink-0 mt-0.5" />
      <div className="flex-1 min-w-0">
        {toast?.title && (
          <p className="font-caption text-sm font-semibold text-foreground">{toast?.title}</p>
        )}
        <p className="font-caption text-xs text-muted-foreground">{toast?.message}</p>
      </div>
      <button
        onClick={() => onDismiss(toast?.id)}
        className="flex-shrink-0 w-5 h-5 flex items-center justify-center rounded hover:bg-muted transition-all duration-200"
      >
        <Icon name="X" size={12} color="var(--color-muted-foreground)" />
      </button>
    </div>
  );
}